import { conciliationRoutes } from "./routes/conciliation/conciliation.routes";
import { taxRoutes } from "./routes/tax/tax.routes";
import { financialRoutes } from "./routes/financial/financial.routes";
import { storeBackOfficeRoutes } from "./routes/store-back-office/store-back-office.routes";
import { itRoutes } from "./routes/it/it-routes";
import { crmRoutes } from "./routes/crm/crm.routes";
import { businessPlanningRoutes } from "./routes/business-planning/business-planning-routes";
import { rhRoutes } from "./routes/rh/rh.routes";
import { priceRemarkRoutes } from "./routes/price-remark/price-remark.routes";
import { remarcacaoDePrecoRoutes } from "./routes/remarcacao-de-preco/remarcacao-de-preco.routes";

export const routes = [
  ...conciliationRoutes,
  ...taxRoutes,
  ...financialRoutes,
  ...storeBackOfficeRoutes,
  ...businessPlanningRoutes,
  ...remarcacaoDePrecoRoutes,
  ...itRoutes,
  ...crmRoutes,
  ...rhRoutes,
  ...priceRemarkRoutes,
];
